const absoluteUrlRegex = new RegExp("^(?:[a-z]+:)?//", "i");

export type AbsoluteUrl = string & {
  readonly __opaque__: unique symbol;
};

export function isAbsoluteUrl(url: string): url is AbsoluteUrl {
  return absoluteUrlRegex.test(url);
}
